import { Button, Flex, Paper, TextInput, Text, Loader } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import {
  displayErrorMessage,
  displayServerErrorMessage,
} from "../shared/ErrorMessage";
import {
  CreateEmailTemplateRequest,
  useCreateEmailTemplateMutation,
} from "../slices/api/emailApi";
import { initialize, updateField } from "../slices/form/createEmailTemplate";
import { useEffect, useRef } from "react";
import { EmailTemplate } from "../slices/types";
import { useLocation } from "wouter";

interface Props {
  ventId: string;
  onClose: () => void;
}
const CreateEmailTemplate = (props: Props) => {
  const { data: emailTemplate } = useAppSelector(
    (state: RootState) => state.createEmailTemplateForm,
  );
  const [createEmailTemplate] = useCreateEmailTemplateMutation();
  const [_, navigate] = useLocation();
  const nameRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(initialize({} as EmailTemplate));
  }, []);

  const handleClick = async () => {
    if (emailTemplate === undefined) {
      console.error("emailTemplate undefined");
      return;
    }
    if (!emailTemplate.name) {
      displayErrorMessage("Name is required.");
      if (nameRef.current) nameRef.current.focus();
      return;
    }

    const request: CreateEmailTemplateRequest = {
      ventId: props.ventId,
      name: emailTemplate.name,
    };

    try {
      const response = await createEmailTemplate(request).unwrap();
      props.onClose();
      navigate(
        `/console/emailTemplate/event/${props.ventId}/emailTemplate/${response.id}`,
      );
    } catch (error) {
      displayServerErrorMessage("Failed to create a new template.");
    }
  };
  if (!emailTemplate) {
    return <Loader color="blue" />;
  }

  return (
    <>
      <Paper>
        <Text size="lg">Add Email Template</Text>
        <TextInput
          ref={nameRef}
          required
          mt="md"
          label="Template name"
          value={emailTemplate.name ?? ""}
          onChange={(event) => {
            dispatch(
              updateField({
                field: "name",
                value: event.currentTarget.value,
              }),
            );
          }}
        />
        <Flex justify="flex-end">
          <Button mt="md" mr="md" onClick={props.onClose}>
            Cancel
          </Button>
          <Button mt="md" onClick={handleClick}>
            Save
          </Button>
        </Flex>
      </Paper>
    </>
  );
};

export default CreateEmailTemplate;
